import { create } from "zustand";
import { approveListApi } from "../services/barCodeMaster";
import { useBarcodeStore } from "./useBarcodeMasterStore";
import { message } from "antd";

export const useBarCodeApproveStore = create((set,get) => ({
  approvedRows: {},
  lastPayload: null, 

  setLastPayload: (payload) => set({ lastPayload: payload }),
  toggleRow: (Id, isChecked) =>
    set((state) => ({
      approvedRows: {
        ...state.approvedRows,
        [Id]: isChecked,
      },
    })),
     clearApprovedRows: () =>
    set({
      approvedRows: {},
    }),
  bulkApprove: async () => {
    const { approvedRows, clearApprovedRows } = get();
    const { lastPayload } = get();
    const { getLiquidationList } = useBarcodeStore.getState();

    const selectedIds = Object.keys(approvedRows)
      .filter((Id) => approvedRows[Id])
      .map(Number);

    if (selectedIds.length === 0) {
      message.error("No rows selected");
    }

    await approveListApi(selectedIds);

    clearApprovedRows();
    if (lastPayload) {
      await getLiquidationList(lastPayload);
    }

    return selectedIds;
  },
  singleApprove: async (id) => {
    const { lastPayload } = get();
    const { getLiquidationList } = useBarcodeStore.getState();

    await approveListApi([id]);

    if (lastPayload) {
      await getLiquidationList(lastPayload);
    }
  },
  clearApproved: () => set({ approvedRows: {} }),
}));
